import {
  getHireJobsListInfiniteQueryOptions,
  getHireJobsListQueryOptions,
  getHireJobsSkillsListQueryOptions,
  getNextPageParam,
  getPreviousPageParam,
} from "@sidegigllc/api/client";
import type { JobQueryParams } from "api/resources/hire";
import type { WarmableQuery } from "routing/warmQueries";

type QueriesInput = { search: JobQueryParams };

const currentStatus = ({ search }: QueriesInput) => search.status ?? "open";

export const jobStatusCountsQuery = () => getHireJobsListQueryOptions({ page_size: 1 });

export const jobsQuery = (input: QueriesInput) => {
  const { position_id, ...search } = input.search;
  const positionId = Number(position_id);
  return getHireJobsListInfiniteQueryOptions(
    {
      ordering: "-created_ts",
      ...search,
      ...(Number.isFinite(positionId) && { position_id: positionId }),
      status: currentStatus(input),
    },
    { query: { getNextPageParam, getPreviousPageParam } },
  );
};

export const jobSkillsQuery = (input: QueriesInput) =>
  getHireJobsSkillsListQueryOptions({ status: currentStatus(input) });

export const queries = (input: QueriesInput): Array<WarmableQuery> => [
  jobStatusCountsQuery(),
  jobsQuery(input),
  jobSkillsQuery(input),
];
